import { render, staticRenderFns } from "./SelectCustom.vue?vue&type=template&id=20736e65&scoped=true"
import script from "./SelectCustom.vue?vue&type=script&lang=js"
export * from "./SelectCustom.vue?vue&type=script&lang=js"
import style0 from "./SelectCustom.vue?vue&type=style&index=0&id=20736e65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20736e65",
  null
  
)

export default component.exports